import { MutationResolvers, ResetPasswordByEmailResponse } from '../../../generated/graphql'
import { env } from '@edge/env'

const url = env.REACT_APP_GRAPHQL_URI
const key = env.REACT_APP_GRAPHQL_API_KEY

const doResetPasswordByEmail: MutationResolvers['doResetPasswordByEmail'] = async (_root, { email }, { client }) => {
    if (!client) {
        throw new Error('Missing client context')
    }

    if (!url) {
        throw new Error('Missing URL')
    }

    if (!key) {
        throw new Error('Missing x-api-key')
    }

    const cleanEmail = email.trim().toLowerCase()

    try {
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'x-api-key': key,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: `mutation resetPasswordByEmail {
          resetPasswordByEmail(input: { email: "${cleanEmail}" }) {
            userEmail
            statusCode
            statusMessage
          }
        }`,
            }),
        })

        const resJson = (await res.json()) as {
            data: { resetPasswordByEmail?: ResetPasswordByEmailResponse }
        }

        const gqRes = resJson.data.resetPasswordByEmail

        if (gqRes?.statusCode !== 200) {
            throw new Error(gqRes?.statusMessage)
        }

        return gqRes
    } catch (error: unknown) {
        console.error(error)
        if (error instanceof Error) {
            return {
                userEmail: email,
                statusCode: 500,
                statusMessage: error.message,
            }
        }
        return {
            userEmail: email,
            statusCode: 500,
            statusMessage: 'Unkown Error. Check logs.',
        }
    }
}

export default doResetPasswordByEmail
